import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "person-circle-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeWidth: 1.5 },
        React.createElement("circle", { cx: 10, cy: 10, r: 8.235 }),
        React.createElement("path", { strokeLinecap: "round", d: "M5.44 13.556C5.914 11.52 7.776 10 10 10c2.224 0 4.086 1.52 4.56 3.556" }),
        React.createElement("circle", { cx: 10, cy: 7.647, r: 2.353 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
